import React from "react";
import { withTranslation } from "react-i18next";
import { GetUrlVars } from "../services/data.service";

class Privacy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    const params = GetUrlVars();
    const address = params.address || window.address || "";
    const contact_mail = params.contact_mail || window.contact_mail || "";

    this.setState({
      address: decodeURIComponent(address),
      contact_mail: decodeURIComponent(contact_mail),
    });
  }

  render() {
    const {t, title, content} = this.props;
    const privacyTitle = title || t("privacy_title", { address: this.state.address });
    const privacyText =
        content ||
        t("privacy_text", { address: this.state.address, contact_mail: this.state.contact_mail });


    return (<section className="z-10 text-gray-700 body-font">
      <div className="relative z-10 container px-5 mt-4 mx-auto">
        <div className="z-10 xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">
          <h2 className="w-full my-2 text-2xl font-bold leading-tight text-center text-gray-800">{privacyTitle}</h2>
          <div className="w-full mb-4">
            <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
          </div>
          <p className="leading-relaxed text-sm text-center whitespace-pre-line" dir="auto">
            {privacyText}
            <br/>
            <br/>
          </p>
        </div>
      </div>
    </section>);
  }

}

// Wrap component with `withTranslation()` for class components
export default withTranslation()(Privacy);
